// extracted by mini-css-extract-plugin
export default {"content":"aX4qvQTJ2BClelXP9KVs","text":"a2PqoXgkm0dkb30CtD2o","link":"HzWI_S38p85RsxELrmJM","linkButton":"arIMMqCAdSHDkd7rQckG","actions":"tEgENeLcrfUQ5pACkuoh"};